module.exports = __webpack_public_path__ + "media/images/service/b_fm-f8e020718ca5b2555a877af3259b4ae1.png";